import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Injectable({
  providedIn: 'root',
})
export class SwalService {
  constructor(private _t: TranslateService) {}

  confirmDialog(callback, options?: SwalOption) {
    const swalOption = {
      title: this._t.instant('Are you sure?'),
      text: this._t.instant("You won't be able to revert this!"),
      customClass: {
        confirmButton: 'btn btn-md btn-primary mr-2',
        cancelButton: 'btn btn-md btn-danger',
      },
      showCancelButton: true,
      confirmButtonText: this._t.instant('Yes, delete it!'),
      cancelButtonText: this._t.instant('Cancel'),
      buttonsStyling: false,
    };

    let opt = { ...swalOption, ...(options || {}) };

    const customClass = {
      ...swalOption.customClass,
      ...(options?.customClass || {}),
    };
    opt.customClass = customClass;

    if (options?.preConfirmValidator) {
      opt.preConfirm = (remarks) => {
        const { error, message } = options.preConfirmValidator(remarks);
        if (error) {
          Swal.showValidationMessage(message);
        }
      };
    }

    Swal.fire(opt).then((result) => {
      if (result.isConfirmed) {
        if (opt.input) {
          callback({
            result,
            resultFunc: () =>
              Swal.fire(
                options?.customConfirmedAttr?.title ||
                  this._t.instant('Deleted!'),
                options?.customConfirmedAttr?.content ||
                  this._t.instant('Your file has been deleted.'),
                options?.customConfirmedAttr?.icon || 'success'
              ),
          });
        } else {
          callback(() =>
            Swal.fire(
              options?.customConfirmedAttr?.title ||
                this._t.instant('Deleted!'),
              options?.customConfirmedAttr?.content ||
                this._t.instant('Your file has been deleted.'),
              options?.customConfirmedAttr?.icon || 'success'
            )
          );
        }
      }
    });
  }
}

export interface SwalOption {
  title?: string;
  text?: string;
  icon?: string;
  input?: string;
  showCancelButton?: boolean;
  showConfirmButton?: boolean;
  confirmButtonColor?: string;
  cancelButtonColor?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  customClass?: {
    confirmButon?: string;
    cancelButton?: string;
    title?: string;
    content?: string;
  };
  preConfirm?: any;
  preConfirmValidator?: any;
  customConfirmedAttr?: {
    title?: string;
    content?: string;
    icon?: string;
  };
}
